export const mcpConsentFrCA = {
  documentTitle: "Approuver une connexion · Invup",
  loginMessage: "Connectez-vous pour approuver une connexion",
  framed: "Ouvrez cette page directement pour approuver la connexion.",
  title: "Approuver une connexion",
  lede: "Une application demande à utiliser votre compte Invup.",
  clientUnverified: "L'application a choisi ce nom. Invup ne le vérifie pas.",
  returnTo: "Après votre choix, vous reviendrez à :",
  returnToLoopback:
    "Après votre choix, vous reviendrez à une application sur cet ordinateur :",
  returnCaution:
    "Continuez seulement si vous avez lancé cette connexion vous-même.",
  returnUnknown:
    "Invup ne peut pas confirmer où cette application vous enverra. Continuez seulement si vous lui faites confiance.",
  signedInAs: "Connecté en tant que {{email}}.",
  switchAccount: "Changer de compte",
  orgLegend: "Organisation",
  orgHelper:
    "La connexion fonctionne seulement dans l'organisation que vous choisissez.",
  orgRole: "Votre rôle : {{role}}",
  orgReason: {
    organization_opted_out:
      "Désactivé par cette organisation. Une personne qui gère les intégrations peut l'activer.",
    feature_required:
      "Nécessite le forfait Pro. Demandez à la personne propriétaire de l'organisation de passer au forfait supérieur.",
    unknown: "Cette organisation ne peut pas se connecter pour le moment.",
  },
  orgRequired: "Choisissez une organisation à connecter.",
  orgNoLongerEligible: "{{organization}} ne peut plus se connecter.",
  orgRefused: "Vous ne pouvez plus connecter {{organization}}.",
  canTitle: "Ce que cette connexion peut faire",
  canIntro:
    "Elle agit en votre nom, avec votre rôle {{role}} dans {{organization}}.",
  canIntroNoRole: "Elle agit en votre nom dans {{organization}}.",
  canPlaceholder:
    "Choisissez une organisation pour voir ce que cette connexion peut y faire.",
  capability: {
    time_logging: {
      self: "Saisir vos propres entrées de temps",
    },
    time_entries: {
      all: "Lire les entrées de temps de tout le monde dans l'organisation",
      self: "Lire vos propres entrées de temps",
    },
    time_entry_editing: {
      all: "Modifier les entrées de temps de tout le monde dans l'organisation, y compris les entrées facturées et les dates verrouillées",
      self: "Modifier vos propres entrées de temps, y compris celles qui sont facturées, sauf aux dates verrouillées",
    },
    time_entry_deletion: {
      all: "Supprimer les entrées de temps de tout le monde dans l'organisation, y compris les entrées facturées et les dates verrouillées",
      self: "Supprimer vos propres entrées de temps, y compris celles qui sont facturées, sauf aux dates verrouillées",
    },
    reports: {
      all: "Lire les sommaires de temps de toute l'organisation",
      self: "Lire les sommaires de votre propre temps",
    },
    projects: {
      all: "Lire les projets",
      self: "Lire les projets auxquels vous êtes affecté",
    },
    clients: {
      all: "Lire les clients",
      self: "Lire les clients des projets auxquels vous êtes affecté",
    },
    services: {
      all: "Lire les services",
    },
  },
  canRoleLimit:
    "Tout ce que votre rôle ne peut pas voir ni modifier dans Invup, cette connexion ne le peut pas non plus.",
  neverTitle: "Ce qu'elle ne pourra jamais faire",
  never: {
    profile:
      "Modifier votre profil, votre mot de passe ou vos paramètres de connexion",
    roles: "Modifier le rôle ou les autorisations de quiconque",
    records:
      "Créer, modifier ou supprimer des projets, des clients, des services ou des factures",
    money: "Voir des taux, des prix ou des montants",
    otherOrgs: "Accéder à une autre organisation que celle que vous choisissez",
  },
  expiryTitle: "Durée de validité",
  expiryBody:
    "Elle cesse de fonctionner après 30 jours sans utilisation. Après 180 jours, vous devrez l'approuver de nouveau. Vous pouvez la déconnecter à tout moment depuis votre profil.",
  deny: "Refuser",
  denying: "Refus…",
  approve: "Approuver",
  approving: "Approbation…",
  loadError:
    "Désolé, cette demande de connexion n'a pas pu être chargée en raison d'une erreur de notre côté. Veuillez réessayer.",
  tryAgain: "Réessayer",
  approveError:
    "Désolé, la connexion n'a pas pu être approuvée en raison d'une erreur de notre côté. Veuillez réessayer.",
  denyError:
    "Désolé, la demande n'a pas pu être refusée en raison d'une erreur de notre côté. Veuillez réessayer.",
  approvedTitle: "Connexion approuvée avec succès",
  approvedBody:
    "{{client}} peut maintenant agir en votre nom dans {{organization}}. Retournez à {{host}} pour terminer la connexion.",
  approvedBodyUnknown:
    "{{client}} peut maintenant agir en votre nom dans {{organization}}. Retournez à l'application pour terminer la connexion.",
  approvedResting:
    "Connexion approuvée. Retournez à {{host}} pour terminer la connexion.",
  approvedRestingUnknown:
    "Connexion approuvée. Retournez à l'application pour terminer la connexion.",
  returnButton: "Retourner à {{host}}",
  returnButtonUnknown: "Retourner à l'application",
  returnBlocked:
    "Invup n'a pas pu vous renvoyer à cette application. Relancez la connexion depuis l'application.",
  deniedTitle: "Connexion refusée",
  deniedBody:
    "Rien n'a été partagé avec {{client}}, et aucune connexion n'a été créée.",
  deniedHelper: "{{client}} indiquera que vous avez refusé la demande.",
  goToDashboard: "Aller au tableau de bord",
  expiredTitle: "Cette demande a expiré",
  expiredBody:
    "Cette demande de connexion n'est plus disponible. Les demandes expirent après 10 minutes et ne peuvent servir qu'une fois. Recommencez la connexion à partir de l'application concernée.",
  unavailableTitle: "Connexions indisponibles",
  unavailableBody:
    "Les connexions sont temporairement indisponibles, donc rien n'a été partagé. Vos connexions existantes sont conservées. Réessayez plus tard.",
  noneTitle: "Aucune de vos organisations ne peut encore se connecter",
  noneOrganization: "{{organization}} : {{reason}}",
  noneAvailable:
    "Aucune de vos organisations ne peut être connectée à partir de ce compte.",
  noneDenyHint: "Refusez la demande pour que {{client}} cesse d'attendre.",
};
